import { FC } from 'react';
import { LoginForm } from 'features/Login';

export const LoginPage: FC = () => {
  return <LoginForm />;
};
